import { render, staticRenderFns } from "./sprite.vue?vue&type=template&id=89b813ea&"
import script from "./sprite.vue?vue&type=script&lang=js&"
export * from "./sprite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports